import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../../components/Logo';
import { styled } from '../../stitches.config';

const SocialMediaIconSize = 29;

const Subtitle = styled('div', {
  marginBottom: '10px',
});

const Links = styled('div', {
  marginTop: '10px',
  '& > *': {
    marginLeft: '15px',
  },
});

const Copyright = styled('div', {
  textAlign: 'center',
  marginBottom: '30px',
  '@media (min-width: 600px)': {
    gridColumnStart: 'span 2',
  },
});

const FollowMe = styled('div', {
  marginBottom: '30px',
  '@media (min-width: 600px)': {
    textAlign: 'right',
  },
});

const StyledFooter = styled('footer', {
  position: 'relative',
  paddingTop: '30px',
  margin: 'auto',
  textAlign: 'center',
  '@media (min-width: 600px)': {
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    width: '80%',
  },
});

const LayoutContainer = styled('div', {
  maxWidth: '1200px',
  margin: 'auto',
});

const Header = styled('div', {
  paddingBottom: '20px',
  margin: 'auto',
  '@media (min-width: 900px)': {
    width: '80%',
  },
});

const StyledLogo = styled(Logo, {
  textAlign: 'center',
  display: 'block',
  margin: 'auto',
  marginBottom: '10px',
  '& img': {
    width: '100%',
  },
  '@media (min-width: 900px)': {
    width: '600px',
  },
});

const Nav = styled('ul', {
  display: 'flex',
  fontSize: '1.2em',
  justifyContent: 'space-around',
  '@media (min-width: 900px)': {
    fontSize: '1.5em',
  },
});

const Content = styled('div', {
  width: '100%',
  boxSizing: 'border-box',
  '@media (min-width: 600px)': {
    padding: '20px',
  },
});

export const Footer = ({ className }: { className?: string }) => {
    return (
        <StyledFooter className={className}>
            <FollowMe>
                <Subtitle>Follow me:</Subtitle>
                <Links>
                    <a href="https://www.instagram.com/seekingsomaart">
                        <img
                            alt="instagram"
                            src={`/images/instagram-${SocialMediaIconSize}.png`}
                        />
                    </a>{' '}
                    <a href="https://www.facebook.com/seekingsomaart">
                        <img
                            alt="facebook"
                            src={`/images/facebook-${SocialMediaIconSize}.png`}
                        />
                    </a>
                </Links>
            </FollowMe>
            <Copyright>
                Copyright {new Date().getFullYear()} Seeking Soma Art LLC.{' '}
                <br />
                All rights reserved.
            </Copyright>
        </StyledFooter>
    );
};

export function Layout({
    children,
    showNav = true,
}: {
    children: any;
    showNav?: boolean;
}) {
    return (
        <LayoutContainer>
            <Header>
                <StyledLogo />
                {showNav && (
                    <Nav>
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <Link to="/about">About</Link>
                        </li>
                        <li>
                            <Link to="/commissions">Commissions</Link>
                        </li>
                        <li>
                            <Link to="/contact">Contact</Link>
                        </li>
                    </Nav>
                )}
            </Header>
            <Content>{children}</Content>
            <Footer />
        </LayoutContainer>
    );
}

export default Layout;
